import React, { useState, useEffect, useContext } from "react";
import UserContext from "../contexts/UserContext";
import { useTranslation } from 'react-i18next';
import "../css/ListUsers.css";
import { useNavigate } from "react-router-dom";
import Select from 'react-select';
import { ddStyles } from "../utils/CommonStyles.js";

let partnerOptions = [];
function UserPartnerDD({ loginId, companyId, setSupplierId, userPartnerList, supplierId }) {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const [error, setError] = useState("");
	const [partnerLoaded, setPartnerLoaded] = useState(false);
	const [userPartners, setUserPartners] = useState([]);
	const [partnerSelected, setPartnerSelected] = useState({ name: "partnerKey", label: "", value: 0, color: "" });
	const userCtx = useContext(UserContext);

	useEffect(() => {
		setUserPartners(userPartnerList);
		setPartnerValues(userPartnerList);
	}, [userPartnerList]);

	const setPartnerValues = (partners) => {
		let partnerValue = [];
		partnerOptions = [];
		if (partners && partners.length > 0) {
			partners.map((aPartner, index) => {
				partnerValue.label = aPartner.companyName;
				partnerValue.value = aPartner.companyId;
				partnerValue.color = aPartner.status === 'Expired' ? 'grey' : aPartner.status === 'In-Active' ? 'red' : '';
				partnerOptions.push(partnerValue);
				if(supplierId == 0){
					if (index == 0) {
						setPartnerSelected({ ...partnerSelected, label: (aPartner.companyName), value: aPartner.companyId });
						setSupplierId(aPartner.companyId);
					}
				} else {
					if(supplierId == aPartner.companyId){
						setPartnerSelected({ ...partnerSelected, label: (aPartner.companyName), value: aPartner.companyId });
						setSupplierId(aPartner.companyId);
					}
				}
				
				partnerValue = {};
			});
			setPartnerLoaded(true);
		} else {
			setSupplierId(0);
		}
	}
	const partnerHandler = (selectedOption) => {
		let companyId = selectedOption ? selectedOption.value : 0;
		let companyName = selectedOption ? selectedOption.label : "";
		setPartnerSelected({ ...partnerSelected, label: companyName, value: companyId });
		setSupplierId(companyId);
	}
	return (
		<>
			{partnerLoaded ?
				<div className="form-group">
					<label className="form-label">
						<span className="form_required">*</span>
						{t("page.supplier")}
					</label>
					<Select
						name="partnerKey"
						options={partnerOptions}
						onChange={partnerHandler}
						placeholder={""}
						value={partnerSelected}
						isSearchable={true}
						isClearable={true}
						className="myselect"
						inputId="partnerKey-input"
						styles={ddStyles}
					/>
				</div>
				: <></>}
		</>
	);
}
export default UserPartnerDD;